import { IGetIncorporacaoImovelDropDownUseCase } from "../../../presentation/useCases/read/get_incorporacao_imovel_drop_down_use_case";
import { DropDown } from "../../../../../common/domain/models/dropdown";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * GetIncorporacaoImovelDropDownUseCaseUseCase
 */

export class GetIncorporacaoImovelDropDownUseCase implements IGetIncorporacaoImovelDropDownUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async execute(idEmpreendimento: number, idsBlocos: number[] = []): Promise<DropDown[]> {
    return this.repository.getIncorporacaoImovelDropDown(idEmpreendimento, idsBlocos);

  }
}
